import React from 'react';

interface Props {
  name: string;
  className?: string;
}

const ScheduleVisitButton = ({name, className}: Props) => (
  <button
    className={`college-profile-schedule-visit-button ${className} mobi-enabled`}
    data-mobi-categories="daily"
    data-mobi-audiences="5"
    data-segment-track="button"
    data-button-name={name}
    type="button"
    aria-label="Schedule a visit (opens dialog)"
  >
    Schedule
  </button>
);

export default ScheduleVisitButton;
